
//import '../../scss/master.scss';

import JQuery, { each } from 'jquery';
import '../../lib/jquery.extendable.js';
import '../../lib/jquery.nivasSelect.js';

// for vuejs
import './gtm.js';

import gsap from "gsap";
// import { ScrollTrigger } from "gsap/ScrollTrigger";

import Swiper, { Navigation, Pagination, Scrollbar } from "swiper";
window.nivas = {					//for Vue
	swiper: {
		Swiper,
		Navigation,
		Pagination,
		Scrollbar
	}
};


// import MicroModal from 'micromodal';
import Headroom from "headroom.js";

// for Vue
window.$ = window.JQuery = JQuery;

var fwajax =
{
	type: 'POST',
	dataType: 'json',
	langSegment: '/',
	verbose: true,

	callback_globalAjaxError: function( XMLHttpRequest, textStatus, errorThrown)
	{
		if(fwajax.verbose)
			alert('ajax error: ' + textStatus );
	}

	,

	phpExecute : function(controlObject)
	{


		var obj=new Object;

		obj[ '_fwajax_url' ] = controlObject.url;
		obj[ '_fwajax' ] = '_fwajax';

		for(var i=1; i<arguments.length; i++)
		{
			var objIx='_fwajax_a' + (i-1);
			obj[ objIx ]=arguments[i];
		}

		var newUrl=fwajax.langSegment;
		if( controlObject.url.length >= 1 && controlObject.url.charAt(0)=='/')
			newUrl += controlObject.url.substr(1);
		else
			newUrl += controlObject.url;

		$.ajax(
			{
				url: newUrl,
				data: obj,
				success: fwajax.jsExecute,
				//error: callback_error_test2,
				timeout: 8000
			}
		);
	} // phpExecute

	,


	jsExecute : function(controlObject, statusText)
	{
		if( typeof( controlObject['_fwajax'] ) == 'undefined' || controlObject['_fwajax']!='_fwajax')
		{
			if(fwajax.verbose)
			{
				alert('jsExecute: Invalid JSON');
			}

			return;
		}

		if( typeof( controlObject['_fwajax_callback'] ) == 'undefined' || controlObject['_fwajax_callback']=='')
		{
			return;
		}

		var callback=controlObject['_fwajax_callback'];

		var evalArgs='';

		for(var i=0; ; i++)
		{
			var ix='_fwajax_a'+i;

			var argType= typeof( controlObject[ix] );

			if( argType == 'undefined')
				break;

			if(evalArgs != '')
				evalArgs += ', ';

			if( argType == 'string')
			{
				//evalArgs += '"' + controlObject[ix].replace(/"/g, '\\"') + '"';
				evalArgs += '"' + controlObject[ix] + '"';
			}
			else
			{
				evalArgs +=  controlObject[ix] ;
			}
		}

		var evalCode=callback+'(' + evalArgs + ')';

		eval( evalCode );

	} // jsExecute
};


$.ajaxSetup(
	{
		type: "POST",
		dataType: "json",
		error: fwajax.callback_globalAjaxError
	}
);

/* 1. Navigation */

function headerNav() {
	var tl = gsap.timeline({
		// paused: true,
		reversed: false,
		/*onReverseComplete: function() {
			gsap.set("#navigation", { display: "none" });
		}*/
	})


	var linksTl = gsap.timeline({
		// paused: true,
		reversed: false,
		/*onReverseComplete: function() {
			gsap.set("#navigation", { display: "none" });
		}*/
	})


	var navCloseTl = gsap.timeline({
		// paused: true,
		reversed: false,
		/*onReverseComplete: function() {
			gsap.set("#navigation", { display: "none" });
		}*/
	})

	$(".js-site-header-open").click(function (e) {
		e.preventDefault();

		$(".site-header__dropdown").addClass("is-active");
		$(this).prop("disabled", true);
		// $(".js-site-header-close").prop("disabled", false);
		$("body").addClass("noscroll");

		/*if ($(this).hasClass("is-active")) {
			$(this).removeClass("is-active");
			$(".site-header").removeClass("is-active");
		} else {
			$(this).addClass("is-active");
			$(".site-header").addClass("is-active");
		}*/

		// animateNav();
		// tl.reversed() ? tl.play() : tl.reverse();

		// desktop
		if (window.matchMedia('(min-width: 992px)').matches) {
			// console.log("desktop anim");

			if (tl.reversed()) {
				tl.play()
			} else {
				tl.to(".close-menu-box__bg", { duration: 0.5, y: '0' })
				.to(".main-menu-box__bg", { duration: 0.5, y: '0'}, "-=0.333" )
				.to(".contact-info-box__bg", { duration: 0.5, y: '0'}, "-=0.167" )
				.to(".social-menu-box", { duration: 0.5, y: '0'}, "-=0.25" )
			}

			if (linksTl.reversed()) {
				linksTl.play()
			} else {
				linksTl.to(".button-close-menu", { duration: 0.35, opacity: 1, delay: 0.117, })
				.to(".main-menu__item", {
					delay: 0.216,
					duration: 0.35,
					stagger: 0.083,
					opacity: 1,
					y: '0'
				})
				.to(".contact-info-box__item", { duration: 0.35, opacity: 1}, "-=0.183" )
				.to(".site-header__mask", { duration: 0.1, opacity: 1})
				.call(function() {
					$(".js-site-header-close").prop("disabled", false);
				})

			}

		}

		// mobile
		else {
			// console.log("mobile anim");

			if (tl.reversed()) {
				tl.play()
			} else {
				/*tl.to(".close-menu-box__bg", { duration: 0.5, y: '0' })
				.to(".main-menu-box__bg", { duration: 0.5, y: '0'}, "-=0.333" )
				.to(".contact-info-box__bg", { duration: 0.5, y: '0'}, "-=0.167" )
				.to(".social-menu-box", { duration: 0.5, y: '0'}, "-=0.25" )*/

				tl.to(".site-header__dropdown-bg", { duration: 0.5, y: '0' })
				.to(".social-menu-box", { duration: 0.35, opacity: 0}, "-=0.5" )
			}

			if (linksTl.reversed()) {
				linksTl.play()
			} else {
				linksTl.to(".button-close-menu", { duration: 0.35, opacity: 1, delay: 0.317, })
				.to(".main-menu-box__bg", {  y: '0' }, "-=0.5" )
				.to(".main-menu__item", {
					delay: 0,
					duration: 0.4,
					stagger: 0.083,
					opacity: 1,
					y: '0',
					x: '0'
				})
				.to(".contact-info-box__item", { duration: 0.35, opacity: 1}, "-=0.7" )
				.to(".social-menu-box", { duration: 0.35, opacity: 1}, "-=0.6" )
				.to(".site-header__mask", { duration: 0.1, opacity: 1})
				.call(function() {
					$(".js-site-header-close").prop("disabled", false);
				})

			}

		}



	});


	$(".js-site-header-close").click(function (e) {
		e.preventDefault();

		// $(".site-header__dropdown").removeClass("is-active");
		$(this).prop("disabled", true);
		// $(".js-site-header-open").prop("disabled", false);
		$("body").removeClass("noscroll");

		/*if ($(this).hasClass("is-active")) {
			$(this).removeClass("is-active");
			$(".site-header").removeClass("is-active");
		} else {
			$(this).addClass("is-active");
			$(".site-header").addClass("is-active");
		}*/

		// tl.reverse();
		// linksTl.reverse();

		// animateNav();
		// tl.reversed() ? tl.play() : tl.reverse();

		if (window.matchMedia('(min-width: 992px)').matches) {

			navCloseTl.to(".site-header__dropdown", {
				// delay: 0.117,
				duration: 0.55,
				// stagger: 0.083,
				height: 0,
				// y: '0'
				onComplete: () => gsap.set([".close-menu-box__bg", ".main-menu-box__bg", ".button-close-menu", ".main-menu__item", ".contact-info-box__item", ".contact-info-box__bg", ".social-menu-box" ], {clearProps: true})
			})
			.call(function() {
				$(".site-header__dropdown").removeClass("is-active");
				// tl.restart();
				// tl.pause();
				// linksTl.restart();
				// linksTl.pause();
			})
			.to(".button-close-menu", { duration: 0.55, opacity: 0, delay: 0.117, }, "-=0.55" )
			.to(".main-menu__item", { duration: 0.55, opacity: 0, delay: 0.117, }, "-=0.55" )
			.to(".contact-info-box__item", { duration: 0.55, opacity: 0}, "-=0.55" )
			.to(".site-header__mask", { duration: 0.45, opacity: 0}, "-=0.5")
			.to(".site-header__dropdown", {
				height: "100%",
			})
			.call(function() {
				$(".js-site-header-open").prop("disabled", false);
			})

		}

		else {
			navCloseTl.to(".site-header__dropdown", {
				// delay: 0.117,
				duration: 0.55,
				// stagger: 0.083,
				height: 0,
				// y: '0'
				onComplete: () => gsap.set([".main-menu-box__bg", ".site-header__dropdown-bg", ".close-menu-box__bg", ".button-close-menu", ".main-menu__item", ".contact-info-box__item", ".contact-info-box__bg", ".social-menu-box" ], {clearProps: true})
			})
			.call(function() {
				$(".site-header__dropdown").removeClass("is-active");
				// tl.restart();
				// tl.pause();
				// linksTl.restart();
				// linksTl.pause();
			})
			.to(".button-close-menu", { duration: 0.55, opacity: 0, delay: 0.117, }, "-=0.55" )
			.to(".main-menu__item", { duration: 0.55, opacity: 0, delay: 0.117, }, "-=0.55" )
			.to(".contact-info-box__item", { duration: 0.55, opacity: 0}, "-=0.55" )
			.to(".site-header__mask", { duration: 0.45, opacity: 0}, "-=0.5")
			.to(".site-header__dropdown", {
				height: "100%",
			})
			.call(function() {
				$(".js-site-header-open").prop("disabled", false);
			})
		}



		// height:0,
	});



}

// function headerNavOpen() {
// 	$(".js-site-header-open").click(function (e) {
// 		e.preventDefault();

// 		$(".site-header__dropdown").addClass("is-active");
// 		$(this).prop("disabled", true);
// 		$(".js-site-header-close").prop("disabled", false);

// 		/*if ($(this).hasClass("is-active")) {
// 			$(this).removeClass("is-active");
// 			$(".site-header").removeClass("is-active");
// 		} else {
// 			$(this).addClass("is-active");
// 			$(".site-header").addClass("is-active");
// 		}*/

// 		animateNav();
// 		// tl.reversed() ? tl.play() : tl.reverse();
// 	});

// }

// function headerNavClose() {
// 	$(".js-site-header-close").click(function (e) {
// 		e.preventDefault();

// 		$(".site-header__dropdown").removeClass("is-active");
// 		$(this).prop("disabled", true);
// 		$(".js-site-header-open").prop("disabled", false);

// 		/*if ($(this).hasClass("is-active")) {
// 			$(this).removeClass("is-active");
// 			$(".site-header").removeClass("is-active");
// 		} else {
// 			$(this).addClass("is-active");
// 			$(".site-header").addClass("is-active");
// 		}*/

// 		animateNav();
// 		// tl.reversed() ? tl.play() : tl.reverse();
// 	});

// }

function mobileLangMenuToggle() {
	$(".js-mobile-lang-menu-toggle").click(function (e) {
		e.preventDefault();

		/*$(".mobile-lang-menu-nav").addClass("is-active");
		$(this).prop("disabled", true);
		$(".js-site-header-open").prop("disabled", false);*/

		if ($(this).hasClass("is-active")) {
			$(this).removeClass("is-active");
			$(".mobile-lang-menu-nav").removeClass("is-active");
		} else {
			$(this).addClass("is-active");
			$(".mobile-lang-menu-nav").addClass("is-active");
		}
	});

}

function animateNav() {
	console.log("animate nav");

	// const tl = gsap.timeline();
	var tl = gsap.timeline({
		// paused: true,
		// reversed: true,
		/*onReverseComplete: function() {
			gsap.set("#navigation", { display: "none" });
		}*/
	})


	tl.to(".close-menu-box__bg", { duration: 0.5, y: '0' })
	.to(".main-menu-box__bg", { duration: 0.5, y: '0'}, "-=0.333" )
	.to(".contact-info-box__bg", { duration: 0.5, y: '0'}, "-=0.167" )
	.to(".social-menu-box", { duration: 0.5, y: '0'}, "-=0.25" )
	// .to(".box", { duration: 1, backgroundColor: "#f38630" }, "+=0.5")
	// .to(".box", { duration: 1, x: 0, rotation: -360 }, "+=0.5")

	// tl.reversed() ? tl.play() : tl.reverse();

}



/* vudu GDPR */

var VuduGdprPlugin = {
  options: {
    necessary: {
      cookieName: "gdpr_level_1_necessary",
      pristine: true,
      disabled: true,
      checked: true,
      el: "gdpr_settings_choice_necessary",
    },
    analytical: {
      cookieName: "gdpr_level_2_analytical",
      pristine: true,
      disabled: false,
      checked: false,
      el: "gdpr_settings_choice_analytical",
    },
    marketing: {
      cookieName: "gdpr_level_3_marketing",
      pristine: true,
      disabled: false,
      checked: false,
      el: "gdpr_settings_choice_marketing",
    },
  },

  init: function () {
    if ($("#gdpr_toolbar").length) {
      this.bindEvent();

      var pristine = true;
      for (var i in VuduGdprPlugin.options) {
        var usersSelection = VuduGdprPlugin.options[i];

        var cookieValue = VuduGdprPlugin.getCookie(usersSelection.cookieName);
        if (cookieValue == 1) {
          pristine = false;

          if (usersSelection.disabled === false) {
            VuduGdprPlugin.options[i].checked = true;

            $("#" + usersSelection.el).prop("checked", true);
          }
        } else if (cookieValue == 0) {
          pristine = false;

          if (usersSelection.disabled === false) {
            VuduGdprPlugin.options[i].checked = false;

            $("#" + usersSelection.el).prop("checked", false);
          }
        }
      }

      if (pristine == false) {
        $("#js-toogle-gdpr").addClass("show");
        VuduGdprPlugin.hideToolbar();
      } else {
        $("#gdpr_toolbar").removeClass("hide");
      }
    }
  },

  bindEvent: function () {
    $("#gdpr_toolbar .x_submit_necessary").on("click", function (e) {
      e.preventDefault();

      VuduGdprPlugin.consentCookie("necessary", true);
      $("#gdpr_settings_choice_necessary").prop("checked", true);
      VuduGdprPlugin.consentCookie("analytical", false);
      $("#gdpr_settings_choice_analytical").prop("checked", false);
      VuduGdprPlugin.consentCookie("marketing", false);
      $("#gdpr_settings_choice_marketing").prop("checked", false);

      $("#gdpr-overlay").hide();
      $("#gdpr_settings_popup").removeClass("show");
      $(".gdpr-msg").removeClass("show");
      $("#gdpr_toolbar").addClass("hide");
      $("#js-toogle-gdpr").addClass("show");
    });

    $("#gdpr_toolbar .x_submit_all").on("click", function (e) {
      e.preventDefault();

      VuduGdprPlugin.consentCookie("necessary", true);
      $("#gdpr_settings_choice_necessary").prop("checked", true);
      VuduGdprPlugin.consentCookie("analytical", true);
      $("#gdpr_settings_choice_analytical").prop("checked", true);
      VuduGdprPlugin.consentCookie("marketing", true);
      $("#gdpr_settings_choice_marketing").prop("checked", true);

      $("#gdpr-overlay").hide();
      $("#gdpr_settings_popup").removeClass("show");
      $(".gdpr-msg").removeClass("show");
      $("#gdpr_toolbar").addClass("hide");
      $("#js-toogle-gdpr").addClass("show");
    });

    $("#gdpr_toolbar a.x_open_setup").on("click", function (e) {
      e.preventDefault();

      $("#gdpr_toolbar .gdpr-prompt__ctrl").toggleClass("active");
      $(this).toggleClass("active");
      $("#gdpr_settings_popup").toggleClass("show");
      $(".gdpr-msg").toggleClass("show");
    });

    $("#js-toogle-gdpr").on("click", function (e) {
      e.preventDefault();

      $("#gdpr_toolbar .gdpr-prompt__ctrl").removeClass("active");
      VuduGdprPlugin.showToolbar();
    });

    $("#gdpr_toolbar .x_submit_selected").on("click", function (e) {
      e.preventDefault();

      $("#gdpr_toolbar input.gdpr_level").each(function (index, item) {
        var name = $(item).val();
        var checked = $(this).prop("checked");
        VuduGdprPlugin.consentCookie(name, checked);
      });

      $("#gdpr_toolbar .gdpr-prompt__ctrl").removeClass("active");
      $("#gdpr_toolbar a.x_open_setup").removeClass("active");

      $("#gdpr-overlay").hide();
      $("#gdpr_settings_popup").removeClass("show");
      $(".gdpr-msg").removeClass("show");
      $("#gdpr_toolbar").addClass("hide");
      $("#js-toogle-gdpr").addClass("show");
    });
  },

  showToolbar: function () {
    $("#gdpr-overlay").show();
    $("#gdpr_toolbar").removeClass("hide");
  },

  hideToolbar: function () {
    $("#gdpr-overlay").hide();
    $("#gdpr_toolbar").addClass("hide");
  },

  consentCookie: function (name, checked) {
    if (VuduGdprPlugin.options[name] !== undefined) {
      var value = checked ? 1 : 0;
      VuduGdprPlugin.setCookie(
        VuduGdprPlugin.options[name].cookieName,
        value,
        365
      );
    }
  },

  consentAllCookie: function () {
    for (var i in VuduGdprPlugin.options) {
      var usersSelection = VuduGdprPlugin.options[i];
      VuduGdprPlugin.consentCookie(usersSelection.cookieName, true);
    }
  },

  setLevel: function (lvl) {
    if (typeof cookieDomainName != "undefined" && cookieDomainName) {
      //$.cookie(VuduGdprPlugin.cookieName, lvl, { expires: 365, path: '/', domain: cookieDomainName });
      VuduGdprPlugin.setCookie(
        VuduGdprPlugin.cookieName,
        lvl,
        365,
        cookieDomainName
      );
    } else {
      //$.cookie(VuduGdprPlugin.cookieName, lvl, { expires: 365, path: '/' });
      VuduGdprPlugin.setCookie(VuduGdprPlugin.cookieName, lvl, 365);
    }
  },

  setMaxLevel: function () {
    if (typeof cookieDomainName != "undefined" && cookieDomainName) {
      //$.cookie(VuduGdprPlugin.cookieName, 4, { expires: 365, path: '/', domain: cookieDomainName });
      VuduGdprPlugin.setCookie(
        VuduGdprPlugin.cookieName,
        4,
        365,
        cookieDomainName
      );
    } else {
      //$.cookie(VuduGdprPlugin.cookieName, 4, { expires: 365, path: '/' });
      VuduGdprPlugin.setCookie(VuduGdprPlugin.cookieName, 4, 365);
    }
  },

  setCookie: function (cname, cvalue, exdays, domain) {
    var domain = typeof domain != "undefined" && domain ? domain : ".";
    var d = new Date();
    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
    var cookieExpires = "expires=" + d.toUTCString();
    var cookieDomain = "domain=" + domain;
    //document.cookie = cname + "=" + cvalue + ";" + cookieExpires + ";" + cookieDomain + ";path=/";
    document.cookie = cname + "=" + cvalue + ";" + cookieExpires;
  },

  getCookie: function (cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(";");
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return null;
  },
};


var wrapTable = function () {

	if($('.article__body').length ) {

		$('.article__body table').each(function() {
			$(this).wrap('<div class="table-wrapper"></div>')
		});

	}
}



/**
 * Newsletter
 */
var ArenaturistNewsletter =
{
    selector : {
        'message': '.newsletter_message',
        'success_message': '.newsletter_message.success',
        'error_message1': '.nm_one.error',
        'error_message1_name': '.nm_one_name.error',
        'error_message1_lastname': '.nm_one_lastname.error',

        'error_message2': '.nm_two.error',
        'error_message3': '.nm_three.error',
        'wrapInputs': '.newsletterWrapInputs',
        'input': '#newsletter_signup input[name=email]',
        'input_name': '#newsletter_signup input[name=first_name]',
        'input_lastname': '#newsletter_signup input[name=last_name]',
        'privola': '#newsletter_signup input[name=privola]',
        'button': '#newsletter_signup [type=submit]'
    },

    init: function()
    {

        console.log("ArenaNewsletter init");

        $(document).on('submit', '#newsletter_signup', function(e) {
            e.preventDefault();
            ArenaturistNewsletter.subscribe($(this));
        });


        $(document).on('submit', '#newsletter_redirect', function(e) {
            e.preventDefault();
            location.href= $(this).attr("data-redirect") + '?email=' + $(this).find('input[name=email]').val();
        });

    },


    subscribe: function($form)
    {
        console.log("ArenaNewsletter subscribe");

        var $input = $(this.selector.input);
        var $input_name = $(this.selector.input_name);
        var $input_lastname = $(this.selector.input_lastname);
        var $privola = $(this.selector.privola);
        var $msg = $(this.selector.message);

        var $errMsg1 = $(this.selector.error_message1);
        var $errMsg1_name = $(this.selector.error_message1_name);
        var $errMsg1_lastname = $(this.selector.error_message1_lastname);
        var $errMsg2 = $(this.selector.error_message2);
        var $errMsg3 = $(this.selector.error_message3);
        var $wrpInps = $(this.selector.wrapInputs);
        var $succesMsg = $(this.selector.success_message);

        $(this.selector.input).removeClass('error');
        $(this.selector.input_name).removeClass('error');
        $(this.selector.input_lastname).removeClass('error');
        $(this.selector.wrapInputs).removeClass('errorArr').removeClass('successArr');
        $msg.removeClass('show');

		var validationOK = true;


		if( $privola.prop('checked') == false )
		{

            // console.log('usli u 1');
			$(this.selector.input).addClass('error');
			$(this.selector.input_name).addClass('error');
			$(this.selector.input_lastname).addClass('error');
            $(this.selector.wrapInputs).addClass('errorArr');
            $(this.selector.error_message3).addClass('show');


			setTimeout( function() {
				$errMsg3.removeClass('show');
				$wrpInps.removeClass('errorArr');
			}, 5000);

			validationOK = false;
        }
        else if(  $input_name.val() == "")
        {
            // console.log('usli u name');
            $(this.selector.input_name).addClass('error');
            $(this.selector.wrapInputs).addClass('errorArr');
            $(this.selector.error_message1_name).addClass('show');
            //setTimeout( ()=> {
            setTimeout( function() {
                $errMsg1_name.removeClass('show');
                $wrpInps.removeClass('errorArr');
            }, 5000);

			validationOK = false;
        }
        else if(  $input_lastname.val() == "")
        {
            // console.log('usli u lastname');
            $(this.selector.input_lastname).addClass('error');
            $(this.selector.wrapInputs).addClass('errorArr');
            $(this.selector.error_message1_lastname).addClass('show');
            //setTimeout( ()=> {
            setTimeout( function() {
                $errMsg1_lastname.removeClass('show');
                $wrpInps.removeClass('errorArr');
            }, 5000);

			validationOK = false;
        }
		else if(  $input.val() == "")
        {
            // console.log('usli u email');
            $(this.selector.input).addClass('error');
            $(this.selector.wrapInputs).addClass('errorArr');
            $(this.selector.error_message1).addClass('show');
            //setTimeout( ()=> {
            setTimeout( function() {
                $errMsg1.removeClass('show');
                $wrpInps.removeClass('errorArr');
            }, 5000);

			validationOK = false;
        }


        if(validationOK)
        {
            var re = /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i;
            if(re.test($input.val()))
            {
                $(this.selector.button).attr("disabled","disabled");

                fwajax.phpExecute(
                    { url: '/' + langCode + '/xnewsletter/subscribe' },
                    $input.val(),
                    $input_name.val(),
                    $input_lastname.val()
                );
				$(this.selector.success_message).addClass('show');
            }
            else
            {
                console.log('Validation u redu');
                $(this.selector.input).addClass('error');
                $(this.selector.wrapInputs).addClass('errorArr');
                $(this.selector.error_message2).addClass('show');
                //setTimeout( ()=> {
                setTimeout( function() {
                    $errMsg2.removeClass('show');
                    $errMsg3.removeClass('show');
                    $wrpInps.removeClass('errorArr');
                }, 5000);
            }
        }

        return false;
    },

    callbackSubscribe: function(str)
    {
        console.log("ArenaNewsletter callbackSubscribe");

        var $input = $(this.selector.input);
        var $privola = $(this.selector.privola);
        var $msg = $(this.selector.message);

        var $sucMsg = $(this.selector.success_message);
        var $wrpInp = $(this.selector.wrapInputs);


        $(this.selector.button).removeAttr("disabled","disabled");
        console.log("str", str);
        if(str)
        {
            var res = jQuery.parseJSON(str);
            console.log("res", res);
            if(res.status>0)
            {
                $(this.selector.success_message).addClass('show');
                $(this.selector.wrapInputs).removeClass('errorArr').addClass('successArr');
                $(this.selector.input).removeClass('error');

/*
                // clickdimensions test
                // start prefill clickdimensions form s nasim podacima
                var $input_email = $(this.selector.input).val();
                var $input_name = $(this.selector.input_name).val();
                var $input_lastname = $(this.selector.input_lastname).val();
                var $privola = $(this.selector.privola).val();
                // console.log($input_email, $input_name, $input_lastname, $privola);

                // Access to XMLHttpRequest at 'xxx' from origin 'yyy' has been blocked by CORS policy: No 'Access-Control-Allow-Origin' header is present on the requested resource.
                var url = 'https://analytics-eu.clickdimensions.com/forms/h/aRwZhxyc4UqSlUdPoB2CUw';
                $.post( url, { firstname: $input_name, lastname: $input_lastname, email: $input_email } )
                .done(function( data ) {
                    console.log( "Data Loaded: " + data );
                });
*/
                $input.val("");
                $privola.prop('checked', false);




                //setTimeout( ()=> {
                setTimeout( function() {
                    $sucMsg.removeClass('show');
                    $wrpInp.removeClass('successArr');

                    // // do the submit
                    // $("#btnSubmit").click();

                }, 5000);

                // ga tracking
                gtm_Tracking.trackEvent('Newsletter', 'submit', 'success', 1);
            }
            else
            {
                $(this.selector.input).addClass('error');
                $(this.selector.wrapInputs).addClass('errorArr');
                $(this.selector.error_message).addClass('show');
            }
        }

    }
};



// Hide footer newsletter on consent page
/*if (document.querySelector('.main-newsletter')) {
	document.querySelector('.site-footer .newsletter').style.display = 'none';
}*/



$(document).ready(function() {
	console.log('App ready!');
	ArenaturistNewsletter.init();
	const header = document.querySelector(".site-header");
	const headroom = new Headroom(header);
	headroom.init();

	$(".js-site-header-close").prop("disabled", true);
	headerNav();
	wrapTable();
	// headerNavOpen();
	// headerNavClose();

	mobileLangMenuToggle();
	//VuduGdprPlugin.init();
	$('.nvsSel').nivasSelect();

});
